import React from 'react'
import UserSearchForm from '../containers/UserSearchForm'
import SearchResults from './SearchResults'
import LgyLoadingIcon from '../../../../components/util/lgy-loading-icon/LgyLoadingIcon'

const SearchPage = ({ searchForUsers, search: { isSearching, isSuccess, isError, results, error } }) =>
  <section>
    <header>
      <h2>Search for Users</h2>
      <p>Wildcard search allowed on indicated fields. Fields are case insensitive.</p>
    </header>
    <UserSearchForm onSubmit={searchForUsers} />
    <div className='usa-width-one-whole'>
      {isSearching
        ? <LgyLoadingIcon />
        : isSuccess
          ? results.length > 0
            ? <SearchResults results={results} />
            : <span>No results found.</span>
          : null /* the initial state will be blank of course */}
    </div>
  </section>

export default SearchPage